import { render, staticRenderFns } from "./AdminParceiros.vue?vue&type=template&id=2328795e"
import script from "./AdminParceiros.vue?vue&type=script&lang=js"
export * from "./AdminParceiros.vue?vue&type=script&lang=js"
import style0 from "./AdminParceiros.vue?vue&type=style&index=0&id=2328795e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports